import { Model } from "./model";

export class BaseModel extends Model {
  id: string = "";
  isDeleted: boolean = false;
  isConstant?: boolean = false; // if IsConstant - API will not allow to set "IsDeleted"
}
